import {useState} from 'react';
import {VscClose} from 'react-icons/vsc';
import {Overlay, Portal, Root} from '@radix-ui/react-dialog';
import CheckSuccess from '../Icons/CheckSuccess';
import {IEnquiryFormDictionary} from '@/dictionaries/components/enquiryForm/types';
import {cn} from '@/lib/utils';
import useDatePickerContext from '@/hooks/useDatePickerContext';

interface SubmittedModalProps {
  formDict: IEnquiryFormDictionary;
}

export default function NotifyVillageAvailabilitySuccessModal({
  formDict,
}: SubmittedModalProps) {
  const [willUnmount, setWillUnmount] = useState(false);

  const {successModalIsOpen, setSuccessModalIsOpen} = useDatePickerContext();

  const handleCloseModal = () => {
    setWillUnmount(true);
    setTimeout(() => {
      setSuccessModalIsOpen(false);
      setWillUnmount(false);
    }, 200);
  };

  return (
    <Root open={successModalIsOpen} onOpenChange={setSuccessModalIsOpen}>
      <Portal>
        <Overlay>
          <div
            className={cn(
              'fixed top-0 left-0 md:top-1/2 md:left-1/2  md:-translate-x-1/2 md:-translate-y-1/2 flex justify-start sm:justify-center items-start sm:items-center bg-black/60 w-full h-[100vh] z-[2147483649]',
              {
                'animate-mobile-close-modal md:animate-close-modal':
                  willUnmount,
                'animate-mobile-open-modal md:animate-open-modal': !willUnmount,
              },
            )}>
            <div className="relative flex flex-col justify-start items-center w-full sm:w-1/2 px-10 py-[50px] bg-white gap-4">
              <button
                className="absolute top-[10px] desktop:-top-[10px] right-[10px] desktop:-right-[10px] flex justify-center items-center w-10 h-10 bg-white shadow-default rounded-full z-10"
                onClick={handleCloseModal}>
                <VscClose className="w-7 h-7 text-gray-500" />
              </button>
              <CheckSuccess />
              <h3 className="text-2xl text-success font-averta-semibold">
                {formDict.datePickerEnquiry.success.title}
              </h3>
              <p className="text-center text-lg">
                {formDict.datePickerEnquiry.success.description}
              </p>
            </div>
          </div>
        </Overlay>
      </Portal>
    </Root>
  );
}
